const Message = ({ speaker, text }) => (
  <div className="message">
    <p>
      <strong>{speaker}</strong>: {text}
    </p>
  </div>
);

export default Message;